import "requestidlecallback-polyfill";

import "./src/css/style.css";
